export const TIMEOUT = 500;
export const MD_BREAKPOINT = 800;
